module.exports = __webpack_public_path__ + "static/media/sort-size-up-alt.e782a660.svg";